import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { SiteLayoutComponent, SiteSection } from "shared/components/site-layout";
import { PageWithSettingsComponent } from 'shared/components/page-with-settings';
import { LoadingComponent } from "shared/components/loading";
import { usePageMeta } from "shared/mechanics/page-meta";
import { prerenderMarkLoaded } from "shared/mechanics/prerender";

import { EtfService, IEtfBackend } from "api/etf";
import { EtfCorrelationService, IEtfCorrelationBackend } from "api/correlations";

import { EtfPageSettingsTitle } from '../shared/settings-title';
import { EtfPageSettingsContent } from "../shared/settings-content";

import { TextMockScreen } from 'shared/ui-kit';

import { EtfPageParams as EtfPageRouteParams, EtfPageSection } from "../model";
import { EtfCorrelationPageContent } from './components/content'


export const EtfCorrelationsPage = () => {
	const params = useParams<EtfPageRouteParams>();
	const [etfInfo, setEtfInfo] = useState<IEtfBackend | null>(null);
	const [etfCorrelationsRub, setEtfCorrelationsRub] = useState<IEtfCorrelationBackend[] | null>(null);
	const [etfCorrelationsUsd, setEtfCorrelationsUsd] = useState<IEtfCorrelationBackend[] | null>(null);

	useEffect(
		() => { EtfService.info(params.ticker).then(etf => setEtfInfo(etf)); },
		[]);
	useEffect(
		() => { EtfCorrelationService.correlations(params.ticker, "RUB").then(correlations => setEtfCorrelationsRub(correlations)); },
		[]);
	useEffect(
		() => { EtfCorrelationService.correlations(params.ticker, "USD").then(correlations => setEtfCorrelationsUsd(correlations)); },
		[])

	usePageMeta({
		title: etfInfo == null
			? 'Загрузка данных'
			: `Корреляции ${etfInfo.ticker}`,
		description: etfInfo == null
			? ''
			: `Корреляции ${etfInfo.ticker} с альтернативными ETF и БПИФ. Поиск самых похожих аналогов на "${etfInfo.shortDescription}" по динамике котировок.`,
		keyWords: etfInfo == null
			? []
			: ['корреляции', 'связи', 'законы', 'аналоги', 'сравнение'],
		canonicalPath: `etf/${params.ticker}/comparison`
	});

	if (etfInfo == null || etfCorrelationsRub == null || etfCorrelationsUsd == null)
		return (
			<SiteLayoutComponent activeSection={SiteSection.None}>
				<LoadingComponent />
			</SiteLayoutComponent>
		);

	prerenderMarkLoaded();

	const numOfTradingMonths = moment(Date.now()).diff(moment(etfInfo.tradingStartDate), 'months', true);
	const content = etfCorrelationsRub.length === 0 && etfCorrelationsUsd.length === 0
		? <TextMockScreen text={numOfTradingMonths < 1 ? "Данные отсутствуют, так как фонд начал торговаться недавно" : "Данные отсутствуют, так как статистика по корреляциям не собрана"} />
		: <EtfCorrelationPageContent ticker={etfInfo.ticker} correlationsRub={etfCorrelationsRub} correlationsUsd={etfCorrelationsUsd} />;

	return (
		<SiteLayoutComponent activeSection={SiteSection.None}>
			<PageWithSettingsComponent
				defaultIsSettingsExpanded={true}
				settingsTitleChild={props => <EtfPageSettingsTitle {...props} ticker={etfInfo.ticker} shortDescription={etfInfo.shortDescription} />}
				settingsContentChild={<EtfPageSettingsContent section={EtfPageSection.CORRELATIONS} etf={etfInfo} />}
				settingCompactModeShowButtonText={etfInfo.ticker}
				contentChild={content} />
		</SiteLayoutComponent>
	)
};